import React, { Component } from 'react'
import { isInstalled } from 'src/serviceWorkerRegistration'
import Alert from '@softwaredev_cegeka/stix-core/dist/components/Alert'
import styles from './swStatusIndicator.module.scss'

class SwStatusIndicator extends Component {
    state = {
        isSwInstalled: false,
        show: true,
    }

    componentDidMount() {
        isInstalled(10000)
            .then(isInstalled => {
                this.setState({ isSwInstalled: isInstalled })
            })
            .catch(() => {})
    }

    render() {
        const { isSwInstalled, show } = this.state

        if (isSwInstalled) {
            return (
                <div className={styles.swStatusIndicator}>
                    <Alert
                        variant="warning"
                        dismissible
                        show={show}
                        onClose={() => this.setState({ show: false })}
                    >
                        Service worker active. <br /> Bundle is served from
                        cache.
                    </Alert>
                </div>
            )
        }
        return null
    }
}

export default SwStatusIndicator
